export class TopListDataResponseModel {
    public start?: Date;
    public end?: Date;
    public rows: Array<Map<string, string>> = [];
}